module.exports = __webpack_public_path__ + "static/tpp-creator02-c4e3e796c97a5dad068b4a48fcdb2e9f.jpg";